import { render, staticRenderFns } from "./PurchasingType.vue?vue&type=template&id=0c39aa3a"
import script from "./PurchasingType.vue?vue&type=script&lang=js"
export * from "./PurchasingType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports